export default "__VITE_ASSET__68dc3f4e__"